import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import './index.scss';

const HeroMedia = ({ webMediaUrl, header1Text, bodyText, backgroundColor, textColor, className }) => {
    const bannerClass = classNames({
        'hero-media': true,
        className
    });

    return (
        <div className={bannerClass}
            style={{
                ...(webMediaUrl && { backgroundImage: `url(${webMediaUrl})` }),
                ...(backgroundColor && { backgroundColor }),
                ...(textColor && { color: textColor })
            }}>
            { header1Text && <h1>{header1Text}</h1> }
            <p>{bodyText}</p>
        </div>
    );
};

HeroMedia.propTypes = {
    webMediaUrl: string,
    header1Text: string,
    bodyText: string,
    backgroundColor: string,
    textColor: string,
    className: string
};

export default HeroMedia;
